(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = [
	'message',
	'mousemove',
	'resize',
	'scroll'
];
(window as any).__Zone_enable_cross_context_check = true;
